import React from 'react';

const TermsPage = () => {
  return (
    <div className="static-page legal-page">
      <h1>Terms of Service</h1>
      <p className="last-updated">Last Updated: January 2024</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing and using this website, you accept and agree to be bound by the terms 
          and provision of this agreement.
        </p>
      </section>

      <section>
        <h2>2. Use of Service</h2>
        <p>
          Our service allows you to purchase digital cheats. All purchases are final 
          and non-refundable unless the cheat access key is invalid or not delivered.
        </p>
      </section>

      <section>
        <h2>3. Payment Terms</h2>
        <p>
          We accept cryptocurrency payments through Plisio. All prices are in USD. 
          Payment must be completed within the specified time frame.
        </p>
      </section>

      <section>
        <h2>4. Delivery</h2>
        <p>
          Digital key are delivered instantly via email after payment confirmation. 
          Delivery may take up to 24 hours in rare cases.
        </p>
      </section>

      <section>
        <h2>5. Refund Policy</h2>
        <p>
          Refunds are only provided if the  code is invalid or not delivered. 
          No refunds for used or partially used codes.
        </p>
      </section>

      <section>
        <h2>6. Prohibited Activities</h2>
        <ul>
          <li>Fraudulent purchases</li>
          <li>Reselling codes (contact admin to be a resellar)</li>
          <li>Using stolen payment methods</li>
          <li>Automated purchases (bots)</li>
        </ul>
      </section>

      <section>
        <h2>7. Contact</h2>
        <p>For questions about these terms, contact us at iwantcheats.store@gmail.com</p>
      </section>
    </div>
  );
};

export default TermsPage;
